(function() {
  const $b275e4b12b98e48a$var$TAG = "[cookie-consent-lock]";
  const $b275e4b12b98e48a$var$LOCK_ATTR = "data-consent-lock-active";
  const $b275e4b12b98e48a$var$BANNER_SELECTOR = "#shopify-pc__banner, #shopify-privacy-banner-div";
  const $b275e4b12b98e48a$var$API_TIMEOUT_MS = 5e3;
  const $b275e4b12b98e48a$var$HIDE_FALLBACK_MS = 500;
  const $b275e4b12b98e48a$var$POLL_INTERVAL_MS = 100;
  class $b275e4b12b98e48a$var$CookieConsentLock extends HTMLElement {
    #locked=false;
    #done=false;
    #onConsent=null;
    #recheck=null;
    #timers=new Set;
    #startTime=0;
    connectedCallback() {
      this.#startTime = performance.now();
      console.log($b275e4b12b98e48a$var$TAG, `connectedCallback fired. element=${this.tagName}`);
      this.#init();
    }
    disconnectedCallback() {
      console.log($b275e4b12b98e48a$var$TAG, `disconnectedCallback — tearing down.`);
      this.#teardown();
    }
    async #init() {
      console.log($b275e4b12b98e48a$var$TAG, `#init() starting.`);
      this.#onConsent = () => this.#unlock("consent-event");
      for (const evt of [ "visitorConsentCollected", "trackingConsentAccepted" ]) {
        document.addEventListener(evt, this.#onConsent);
        window.addEventListener(evt, this.#onConsent);
      }
      const cp = await this.#waitForApi();
      if (!cp) {
        console.warn($b275e4b12b98e48a$var$TAG, `Customer Privacy API unavailable. No lock applied.`);
        return;
      }
      console.log($b275e4b12b98e48a$var$TAG, `Customer Privacy API found.`);
      this.#recheck = setInterval(() => {
        if (this.#done) return;
        const apiSaysShow = this.#shouldShow(cp);
        const bannerInDom = !!document.querySelector($b275e4b12b98e48a$var$BANNER_SELECTOR);
        if (apiSaysShow && bannerInDom && !this.#locked) this.#lock(); else if (this.#locked && (!apiSaysShow || !bannerInDom)) this.#unlock("recheck-resolved-or-banner-removed");
      }, $b275e4b12b98e48a$var$POLL_INTERVAL_MS);
    }
    #shouldShow(cp) {
      try {
        return cp.shouldShowBanner?.() === true;
      } catch (err) {
        console.error($b275e4b12b98e48a$var$TAG, `#shouldShow() threw:`, err);
        return false;
      }
    }
    #waitForApi() {
      return new Promise(resolve => {
        const cp = window.Shopify?.customerPrivacy;
        if (cp?.shouldShowBanner) return resolve(cp);
        const started = Date.now();
        const poll = () => {
          const currentCp = window.Shopify?.customerPrivacy;
          if (currentCp?.shouldShowBanner) {
            console.log($b275e4b12b98e48a$var$TAG, `API found after ${Date.now() - started}ms.`);
            return resolve(currentCp);
          }
          if (Date.now() - started >= $b275e4b12b98e48a$var$API_TIMEOUT_MS) return resolve(null);
          this.#timers.add(setTimeout(poll, $b275e4b12b98e48a$var$POLL_INTERVAL_MS));
        };
        poll();
      });
    }
    #lock() {
      if (this.#locked) return;
      console.log($b275e4b12b98e48a$var$TAG, `Applying lock.`);
      this.#locked = true;
      this.style.removeProperty("display");
      this.setAttribute($b275e4b12b98e48a$var$LOCK_ATTR, "");
      document.documentElement.setAttribute($b275e4b12b98e48a$var$LOCK_ATTR, "");
    }
    #unlock(reason) {
      if (!this.#locked || this.#done) return;
      console.log($b275e4b12b98e48a$var$TAG, `#unlock("${reason}") — starting.`);
      this.#done = true;
      this.#teardown();
      this.removeAttribute($b275e4b12b98e48a$var$LOCK_ATTR);
      document.documentElement.removeAttribute($b275e4b12b98e48a$var$LOCK_ATTR);
      this.#hideAfterTransition();
    }
    #hideAfterTransition() {
      let settled = false;
      const finish = () => {
        if (settled) return;
        settled = true;
        this.removeEventListener("transitionend", onEnd);
        this.style.display = "none";
        console.log($b275e4b12b98e48a$var$TAG, `Hide transition finished. Element hidden.`);
      };
      const onEnd = e => {
        if (e.target === this) finish();
      };
      this.addEventListener("transitionend", onEnd);
      this.#timers.add(setTimeout(finish, $b275e4b12b98e48a$var$HIDE_FALLBACK_MS));
    }
    #teardown() {
      if (this.#onConsent) {
        for (const evt of [ "visitorConsentCollected", "trackingConsentAccepted" ]) {
          document.removeEventListener(evt, this.#onConsent);
          window.removeEventListener(evt, this.#onConsent);
        }
        this.#onConsent = null;
      }
      if (this.#recheck) {
        clearInterval(this.#recheck);
        this.#recheck = null;
      }
      this.#timers.forEach(clearTimeout);
      this.#timers.clear();
    }
  }
  if (!customElements.get("cookie-consent-lock")) customElements.define("cookie-consent-lock", $b275e4b12b98e48a$var$CookieConsentLock);
})();